import { render, staticRenderFns } from "./ProgramCourses.vue?vue&type=template&id=1e46894e&scoped=true"
import script from "./ProgramCourses.vue?vue&type=script&lang=js"
export * from "./ProgramCourses.vue?vue&type=script&lang=js"
import style0 from "./ProgramCourses.vue?vue&type=style&index=0&id=1e46894e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e46894e",
  null
  
)

export default component.exports